import React, { useState, useEffect } from "react";
import { message } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import TableContainer from "../../components/TableContainer";
import { useDispatch, useSelector } from "react-redux";
import Smcs_Loader from "../../assests/images/loader-new.gif";
import { getReportData } from "../../actionsMethods/hubReconciliationMethods";
import { getToken, getPremiseId } from "../../utils/worker";

const HubReconciliationReportView = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const reconcileId = location.state?.reconcileId || searchParams.get("reconcileId");

  const [data, setData] = useState([]);

  const {
    fetching: isFetching,
    result: reportData,
    error: isError,
  } = useSelector((state) => state.hubReconciliationReducer.getReportData);

  const fetchReportData = () => {
    const tokenStr = getToken();
    const token = tokenStr?.startsWith("Bearer ") ? tokenStr.split("Bearer ")[1] : tokenStr;
    const premiseIdStr = getPremiseId();
    const premiseId = premiseIdStr?.startsWith("Bearer ") ? premiseIdStr.split("Bearer ")[1] : premiseIdStr;
    const userInfoData = JSON.parse(localStorage.getItem("userId") || "{}");
    const userId = userInfoData?.userInfo?.userId ? userInfoData.userInfo.userId.toString() : "";

    dispatch(getReportData({ reconcileId, token, premiseId, userId }));
  };

  useEffect(() => {
    if (reconcileId) {
      fetchReportData();
    } else {
      message.error("Invalid Reconcile ID", 1);
    }
  }, [reconcileId]);

  useEffect(() => {
    if (reportData) {
      const responseData = reportData?.data || reportData || [];
      const items = Array.isArray(responseData) ? responseData : (Array.isArray(responseData.data) ? responseData.data : []);
      setData(items);
    } else if (isError) {
      message.error("Failed to load Report data", 1);
    }
  }, [isError, reportData]);

  const columns = [
    {
      title: "AWB Number",
      dataIndex: "awbNumber",
      key: "awbNumber",
      render: (text) => (
        <span
          style={{ color: "#1890ff", cursor: "pointer", textDecoration: "underline" }}
          onClick={() => window.open(`/shipment-tracker?awb=${text}`, "_blank")}
        >
          {text}
        </span>
      )
    },
    { title: "Status", dataIndex: "status", key: "status" },
    { title: "Scanned By", dataIndex: "scannedBy", key: "scannedBy" },
    { title: "Premise Name", dataIndex: "premiseName", key: "premiseName" },
    { title: "Reconcile ID", dataIndex: "reconcileId", key: "reconcileId" },
  ];

  return (
    <div className="dashboard-container" style={{ padding: "20px" }}>
      <div className="align-center space-between" style={{ marginBottom: 16 }}>
        <div className="pl-1-5 fw-600 d-flex align-items-center" style={{ fontSize: 20 }}>
          <ArrowLeftOutlined 
            style={{ fontSize: 20, cursor: "pointer", marginRight: 16 }} 
            onClick={() => navigate(-1)} 
          />
          Reconciliation Report
        </div>
      </div>
      <div className="master-main-container view-all-staff">
        <TableContainer
          className="table-head-sticky"
          dataSource={data}
          columns={columns}
          rowKey={(record, index) => record.awbNumber || index}
          loading={{
            indicator: (
              <img
                src={Smcs_Loader}
                style={{ height: "100px", width: "100px" }}
              />
            ),
            spinning: isFetching,
          }}
          pagination={{ pageSize: 50 }}
          scroll={{ x: "max-content" }}
        />
      </div>
    </div>
  );
};

export default HubReconciliationReportView;
